import { AbstractControl } from '@angular/forms';
import { Helpers } from './helpers';

export class EmailValidator {
  public static validate(control: AbstractControl): { [key: string]: boolean } {
    if (Helpers.isNotPresent(control)) {
      return undefined;
    }
    const pattern =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    const emails = control.value.split(/, |; |,|;/g);
    let result;
    emails.forEach((email) => {
      if (!pattern.test(email)) {
        result = { emailvalidator: true };
        return;
      }
    });

    return result;
  }
}
